import React from 'react';
import { withDataProvider } from 'react-admin';
import LoadingIndicator from '../../../components/LoadingIndicator';
import { handleAPIErrors } from '../../../utils';
import { connect } from 'react-redux';

class CustomWebsitesEditStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    ({ dataProvider: this.dataProvider } = this.props);
  }

  componentDidMount() {
    this.loadResources();
  }

  componentDidUpdate(prevProps) {
    if (this.props.chosenLanguage !== prevProps.chosenLanguage) {
      this.loadResources();
    }
  }

  sanitizeTemplates(data) {
    for (let editedData in data) {
      if (data[editedData].hasOwnProperty('html')) {
        let template = data[editedData];
        delete template['@context'];
        delete template['@type'];
        delete template['date'];
        delete template['originId'];
        delete template['publishNow'];

        // Deletes template id from payload when account is null, so it doesn't override global templates.
        // If it is a template assigned to present account, it makes sure it has current template's id and updates current template.
        if (template.account === null) {
          delete template['@id'];
          delete template['id'];
        } else {
          template['id'] = this.props.resourceId;
          template['@id'] = this.props.resourceId;
        }

        if (!(template.name.includes(this.props.website.name))) {
          template.name = this.props.website.name + ' - ' + template.name;
        }
        template.account = this.props.website.account;

        data[editedData] = template;
      }
    }

    return data;
  }

  getCurrentLanguageConsentText = (cookieConsentText) => {
    return cookieConsentText.language === this.props.chosenLanguage;
  };

  async handleSubmit(data) {
    data = this.sanitizeTemplates(data);
    delete data['websiteName'];
    this.props.onSubmit(data);
  }

  loadResources(dataChanged = null) {
    let resourceId = this.props.resourceId;

    this.setState(prevState => Object.assign({}, prevState, {
      cookieConsentText: {},
    }));

    if (this.props.chosenLanguage && this.props.resourceSource) {
      Promise.all([
        this.dataProvider.getMany(this.props.resourceSource, { ids: [resourceId] }),
        this.dataProvider.getMany('cookie_consent_texts', { ids: this.props.cookieConsentTextsIds || [] }),
      ])
        .then(([resourceTemplate, cookieConsentTexts]) => {
          let changedConsentText = cookieConsentTexts.data.filter(this.getCurrentLanguageConsentText)[0];

          this.setState({
            [this.props.resourceName]: dataChanged ? dataChanged[this.props.resourceName] : resourceTemplate.data[0],
            cookieConsentText: changedConsentText,
          });
        })
        .catch(error => {
          handleAPIErrors(error, this.props.history);
          console.error(error);
        });
    }
  }

  render() {
    const { id } = this.props;
    const initialValues = {
      cookieConsentText: this.state.cookieConsentText,
      [this.props.resourceName]: this.state[this.props.resourceName],
      websiteName: this.props.website.name,
    };

    const Form = this.props.form;
    return <div>
      {
        this.state[this.props.resourceName] ?
          <Form initialValues={initialValues} onSubmit={(data) => this.handleSubmit(data)} id={id} enableReinitialize="true"/>
          : <LoadingIndicator/>
      }
    </div>;
  }
}

export const WebsitesEditStep = connect()(withDataProvider(CustomWebsitesEditStep));
